module.exports = function (angularModule) {
  angularModule.directive('cmProviderStatusLegend', function (providerJobStatusService) {

    return {
      restrict: 'E',
      template: `
      <h4 style="margin-top:20px">Status Legend</h4>
      <div ng-repeat="status in statuses" class="status-legend-item">
      <div class="row"><div class="col-xs-2"><i class="status-bauble xx-small {{status.code}}"></i></div>
      <div class="col-xs-10"><span>{{status.title}}:</span> {{status.description}}</div></div>
      </div>`,
      link: function ($scope) {
        $scope.statuses = providerJobStatusService.possibleStatuses
      }
    }
  });
}
